import instance from "../../axios/axios-user";
import { PostAudioProps } from "../../redux/slices/postAudio/postAudio";
import { API_PATHS } from "../api_paths";

const uploadAudioToAPost = ({
  audioFile,
  post_id,
  content_id,
}: PostAudioProps.uploadAudioToAPostPayload) => {
  const formData = new FormData();
  formData.append("audio", audioFile);
  formData.append("content_id", content_id);

  return instance(API_PATHS.posts.post + post_id + "/audio", {
    method: "POST",
    data: formData,
  });
};

const createAudioDraftForAPost = ({
  post_id,
}: PostAudioProps.createAudioDraftForAPostPayload) => {
  return instance(API_PATHS.posts.post + post_id + "/audio-draft", {
    method: "POST",
  });
};

const uploadAudioBackgroundImage = ({
  post_id,
  image,
  gradient,
  content_id,
}: PostAudioProps.uploadAudioBackgroundImagePayload) => {
  const formData = new FormData();
  formData.append("content_id", content_id);
  image && formData.append("image", image);
  gradient && formData.append("gradient", JSON.stringify(gradient));

  return instance(API_PATHS.posts.post + post_id + "/audio-image", {
    method: "POST",
    data: formData,
  });
};

const deleteAnAudioImageFromAPost = ({
  post_id,
  content_id,
}: PostAudioProps.deleteAnAudioImageFromAPostPayload) => {
  return instance(
    API_PATHS.posts.post + post_id + "/audio-image/" + content_id,
    {
      method: "DELETE",
      data: { post_id, content_id },
    }
  );
};

const deleteAudioFromAPost = ({
  post_id,
  audio_id,
}: PostAudioProps.deleteAudioFromAPostPayload) => {
  return instance(API_PATHS.posts.post + post_id + "/audio/" + audio_id, {
    method: "DELETE",
  });
};

const getPostAudio = (post_id: string) =>
  instance(API_PATHS.postAudio.getPostAudio + post_id);

export const POSTAUDIO = {
  uploadAudioToAPost,
  createAudioDraftForAPost,
  uploadAudioBackgroundImage,
  deleteAnAudioImageFromAPost,
  deleteAudioFromAPost,
  getPostAudio,
};
